<template>
	<div id="menu-block">
        <v-layout align-center justify-center row fill-height class="hidden-md-and-down">
          <div class="menu-bar menu-bar-left">
            <v-layout align-center justify-end>
              <span id="filler"></span>
              <router-link class="mr-2 theme-font" :to="menuItems[0].path">{{menuItems[0].label}}</router-link>
              <router-link class="mr-2 theme-font" :to="menuItems[1].path">{{menuItems[1].label}}</router-link>
            </v-layout>
          </div>
          <div>
            <!-- <v-img src="assets/logo-1x.png" /> -->
            <span id="logo"></span>
          </div>
          <div class="menu-bar menu-bar-right">
            <v-layout align-center justify-start>
				<router-link class="mr-2 theme-font" :to="menuItems[2].path">{{menuItems[2].label}}</router-link>
				<router-link class="mr-2 theme-font" :to="menuItems[3].path">{{menuItems[3].label}}</router-link>
				<router-link class="mr-2 theme-font" :to="menuItems[4].path">{{menuItems[4].label}}</router-link>
            </v-layout>
          </div>
        </v-layout>
		<v-layout justify-center class="hidden-lg-and-up">
			<span id="logo" class="mob"></span>
		</v-layout>
		<v-layout align-center justify-center row fill-height class="hidden-lg-and-up" id='menu-dialog'>
			<v-dialog  v-model="menudialog" fullscreen hide-overlay transition="dialog-bottom-transition">
				<template v-slot:activator="{ on }">
					<v-btn id='menu-button' v-on="on">
					</v-btn>
				</template>
				<v-card>	
					<v-btn icon dark @click="menudialog = false" id="menu-close-button">
					</v-btn>
					<div id="menu-dialog-items">	
						<v-layout align-center justify-space-around column fill-height @click="menudialog = false">
							<router-link :to="menuItems[0].path" >{{menuItems[0].label}}</router-link>
							<router-link :to="menuItems[1].path" >{{menuItems[1].label}}</router-link>
							<router-link :to="menuItems[2].path" >{{menuItems[2].label}}</router-link>
							<router-link :to="menuItems[3].path" >{{menuItems[3].label}}</router-link>
							<router-link :to="menuItems[4].path" >{{menuItems[4].label}}</router-link>
						</v-layout>
					</div>
				</v-card>
			</v-dialog>
		</v-layout>
	</div>
</template>

<script>
  export default {
	props:["menuItems"],
    data: () => ({
		menudialog: false,
        notifications: false,
        sound: true,
        widgets: false
    })
  }
</script>

<style>
.v-dialog.v-dialog--fullscreen, .v-dialog.v-dialog--active.v-dialog--fullscreen,.v-dialog.v-dialog--active.v-dialog--fullscreen .v-sheet.theme--light{
	border:none;
	border-width:0;
	border-color:transparent;
	border-radius:0;
	background:#00aaad;
}

#menu-button,#menu-close-button{
	border-radius:0;
	color:#fff;
	background:#00aaad;
	height:56px;
	width:56px;
	line-height:56px;
	position:absolute;
	top:0;
	left:0;
	box-shadow: none;
	z-index: 1;
	min-width:56px;
}
#menu-button{
	background:url('./../assets/menu.svg');
	background-size:100%;
}
#menu-close-button{
	margin-top: 6px;
	margin-left: 8px;
	background:url('./../assets/exit-menu.svg');
	background-size:100%;
}
#menu-dialog-list,#menu-dialog-list li{
	list-style-type:none;
	margin:0;
	padding:0;
}
#menu-dialog-list a,#menu-dialog-list a:hover{
	text-decoration:none;
}
#menu-dialog-items{
	font-size:45px;
	text-align:center;
}
#menu-dialog-items a,#menu-dialog-items a:visited,#menu-dialog-items a:hover,#menu-dialog-items a{
	margin-top:30px;
	text-decoration:none;
	color:#fff;
}
#menu-block, #menu-block a,#menu-block a:visited,#menu-block a:link{
	color:#ffd500;
	font-size:26px;
	padding-top:6px;
	text-decoration:none;
}
.menu-bar{
	background-color: #00aaad;
	flex-grow: 1;
}
.menu-bar-left{
	border-radius: 0px 48px 48px 0px;
	padding-right: 30px;

}
.menu-bar-right{
	border-radius: 48px 0px 0px 48px;
	padding-left: 30px;
}

.menu-bar a.mr-2{
	height:72px;
	line-height:72px;
	margin:0 16px;
	text-transform:uppercase;
}

.menu-bar .router-link-exact-active,.menu-bar a:hover, #menu-dialog-items .router-link-exact-active,#menu-dialog-items a:hover   {
  background:url('./../assets/underline.svg') bottom center repeat-x;
  background-size:130px 14px;
}
.menu-bar .v-btn--active::before, .menu-bar .v-btn:hover::before, .menu-bar .v-btn:focus::before {
    background-color: transparent;
}
#menu-block #logo.mob{
	margin-bottom: 0px;
}
@media screen and (max-width:480px){
	#menu-block #logo.mob{
		margin-bottom: -20px;
	}
}
@media screen and (max-width:420px){
	#menu-block #logo.mob{
		margin-bottom: -15px;
	}
}
@media screen and (max-width:650px){
	.v-messages__wrapper .v-messages__message {		
		padding: 9px 14px!important;
		top:-20px!important;
		right:-2px!important;
	}
}
</style>